import { render } from "./AdminTopComponent.vue?vue&type=template&id=055587cf&scoped=true&ts=true"
import script from "./AdminTopComponent.vue?vue&type=script&lang=ts"
export * from "./AdminTopComponent.vue?vue&type=script&lang=ts"

import "./AdminTopComponent.vue?vue&type=style&index=0&id=055587cf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-055587cf"]])

export default __exports__